import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../../../../app/configcontext';
import { useDispatch, useSelector } from 'react-redux';
import { businessSlice } from '../../../../../../features/business/businessSlice';
import ProtectedPaymentRoute from '../../../../../auth/Auth';

export default function BusinessType() {
  ProtectedPaymentRoute();

  const navigate = useNavigate();
  const state = useSelector((state) => state.business);
  const businessTypeId = state.businessTypeId;
  const config = useConfig();
  const businessCategory = config?.businessCategory || [];

  const [selectCategory, setSelectCategory] = useState(null);
  const [categoryError, setCategoryError] = useState('');
  const actions = businessSlice.actions;
  const dispatch = useDispatch();

  useEffect(() => {
    const storedCategory = localStorage.getItem('selectedCategory');
    if (storedCategory) {
      try {
        const parsedCategory = JSON.parse(storedCategory);
        setSelectCategory(parsedCategory);
      } catch {
        // ignore parse error
      }
    }
  }, []);

  const handleNextButtonClick = (event) => {
    event.preventDefault();
    if (!selectCategory) {
      setCategoryError('Please select a business category.');
      return;
    }

    dispatch(actions.update_business_type(selectCategory.businessCategoryId));
    localStorage.setItem('selectedCategory', JSON.stringify(selectCategory));

    if (businessTypeId === 1) {
      navigate('/member');
    } else {
      navigate('/member_corpo');
    }
  };

  const handleNextpress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleNextButtonClick(event);
    }
  };

  const backbtn = () => {
    if (businessTypeId === 1) {
      navigate("/contact_details");
    } else {
      navigate("/corp_question/1");
    }
  };

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans flex items-center">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
          
          {/* Left Graphic */}
          <div className="lg:col-span-5 flex justify-center items-center">
            <img 
              src="/Assets/Form_img/factory.png" 
              alt="Business Activity" 
              className="w-full max-w-[340px] h-auto object-contain"
            />
          </div>

          {/* Right Form */}
          <div className="lg:col-span-7">
            <div className="mb-8">
              <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
                Business Activity & Industry
              </span>
              <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
                What will your business do?
              </h1>
              <p className="text-[15px] text-[#5f6368] leading-relaxed">
                Select the primary industry category that best describes your company's core operations.
              </p>
            </div>

            <form onKeyDown={handleNextpress} className="space-y-6 max-w-xl">
              <div>
                <label className="block text-[14px] font-medium text-[#3c4043] mb-2">
                  Business Industry / Category <span className="text-[#d93025] font-semibold">*</span>
                </label>
                <Select
                  showSearch
                  placeholder="Select Industry or Activity"
                  size="large"
                  className="w-full"
                  options={businessCategory.map((cat) => ({
                    label: cat.name,
                    value: cat.businessCategoryId,
                  }))}
                  value={selectCategory ? selectCategory.businessCategoryId : null}
                  onChange={(val) => {
                    const matchedCat = businessCategory.find((cat) => cat.businessCategoryId === val);
                    setSelectCategory(matchedCat || null);
                    setCategoryError('');
                  }}
                  status={categoryError ? "error" : ""}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                />
                {categoryError && (
                  <p className="text-[#d93025] text-[13px] mt-1.5 flex items-center gap-1 font-medium">
                    <svg className="w-3.5 h-3.5 inline flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd"></path></svg>
                    {categoryError}
                  </p>
                )}
              </div>

              <div className="flex items-center gap-4 pt-6">
                <button
                  type="button"
                  onClick={backbtn}
                  className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
                >
                  <i className="fa-solid fa-arrow-left text-xs"></i> Back
                </button>
                <button
                  type="button"
                  onClick={handleNextButtonClick}
                  className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
                >
                  Next <i className="fa-solid fa-arrow-right text-xs"></i>
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
}
